import { Link } from "wouter";
import { MapPin, Clock, Mail, LogIn } from "lucide-react";
import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import NewsletterSignup from "@/components/sections/newsletter-signup";
import { WarehouseStock } from "@/components/sections/warehouse-stock";
import { HomeHero } from "@/components/home/home-hero";
import { ProofStrip } from "@/components/home/proof-strip";
import { Services } from "@/components/home/services";
import { About } from "@/components/home/about";
import { Sectors } from "@/components/home/sectors";
import { Reviews } from "@/components/home/reviews";
import { CaseStudyPreview } from "@/components/case-study-preview";
import "@/components/home/home.css";

export default function Home() {
  return (
    <div className="vx-home flex flex-col min-h-[100dvh] bg-background overflow-x-clip">
      <div className="bg-[hsl(var(--vx-blue))] text-white py-1.5 px-4 lg:px-8 text-[0.8125rem] tracking-[0.005em] hidden sm:block border-b border-white/[0.06]">
        <div className="w-full flex justify-between items-center">
          <div className="flex items-center gap-4 md:gap-0 md:divide-x md:divide-white/10 [&>span]:md:px-4 [&>span:first-child]:md:pl-0">
            <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[hsl(var(--vx-frost))]" /> London & Surrounding Areas</span>
            <span className="hidden md:flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[hsl(var(--vx-frost))]" /> Emergency Callouts Available</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="mailto:info@vertexclimate.co.uk" className="flex items-center gap-1.5 hover:text-white transition-colors" data-testid="link-top-email">
              <Mail className="w-3.5 h-3.5 text-[hsl(var(--vx-frost))]" /> info@vertexclimate.co.uk
            </a>
            <Link href="/login" className="flex items-center gap-1.5 font-semibold text-white/90 bg-white/[0.06] ring-1 ring-white/15 hover:bg-white/15 hover:text-white px-3 py-0.5 rounded-full transition-colors" data-testid="link-top-login">
              <LogIn className="w-3.5 h-3.5" /> Login
            </Link>
          </div>
        </div>
      </div>

      <Header />

      <main className="flex-1">
        <HomeHero />
        <ProofStrip />
        <Services />
        <WarehouseStock />
        <About />
        <CaseStudyPreview title="Recent gym projects" />
        <Sectors />
        <Reviews />
        <NewsletterSignup />
      </main>

      <Footer />
    </div>
  );
}
